import countriesData from '@/data/countries.json';

export interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
  nationalLength: number;
  exampleNational: string;
  formatGroups: number[];
  validationRegex: string;
}

export const COUNTRIES: Country[] = countriesData as Country[];
export const DEFAULT_COUNTRY: Country = COUNTRIES[0];

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((c) => c.code === code);
}

export function cleanPhone(value: string, country: Country): string {
  return value.replace(/\D/g, '').slice(0, country.nationalLength);
}

export function formatPhone(value: string, country: Country): string {
  const digits = cleanPhone(value, country);
  const parts: string[] = [];
  let pos = 0;
  for (const len of country.formatGroups) {
    if (pos >= digits.length) break;
    parts.push(digits.slice(pos, pos + len));
    pos += len;
  }
  return parts.join(' ');
}

export function toE164(value: string, country: Country): string {
  return `${country.dialCode}${cleanPhone(value, country)}`;
}

export function isValidPhone(value: string, country: Country): boolean {
  const digits = cleanPhone(value, country);
  return new RegExp(country.validationRegex).test(digits);
}

export function parseE164(e164: string): { country: Country; national: string } | null {
  if (!e164 || !e164.startsWith('+')) return null;
  const sorted = [...COUNTRIES].sort((a, b) => b.dialCode.length - a.dialCode.length);
  const country = sorted.find((c) => e164.startsWith(c.dialCode));
  if (!country) return null;
  const rest = e164.slice(country.dialCode.length);
  return { country, national: formatPhone(rest, country) };
}

export function formatPhoneForDisplay(e164: string | null | undefined): string | null {
  if (!e164) return null;
  const parsed = parseE164(e164);
  if (!parsed) return e164;
  return `${parsed.country.dialCode} ${parsed.national}`;
}
